import { reactive } from 'vue'

const snackbarState = reactive({
  isVisible: false,
  type: '',
  text: '',
})

export const snackbarService = {
  state: snackbarState,

  show(info) {
    if (typeof info === 'string') {
      snackbarState.type = 'error'
      snackbarState.text = info
    } else {
      const typeMap = {
        success: 'success',
        error: 'error',
        alert: 'alert',
      }
      snackbarState.type = typeMap[info.snackbarColor] || info.type || 'default'
      snackbarState.text = info.message || info.text || ''
    }
    snackbarState.isVisible = true
  },

  close() {
    snackbarState.isVisible = false
  },
}
